import { memo } from 'react';
import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Uch holatli filtr.
 *
 * Bosilgan sari holat almashadi:
 *   1) tanlanmagan  — chiziqcha (–)  →  filtr qo'llanmaydi, hamma chiqadi
 *   2) yoqilgan     — belgi (✓)      →  ?query=1  (faqat "ha" bo'lganlar)
 *   3) o'chirilgan  — bo'sh katak    →  ?query=0  (faqat "yo'q" bo'lganlar)
 *   → yana tanlanmagan holatga qaytadi.
 *
 * Oddiy checkbox'dan farqi shunda: "umuman tegilmagan" va "ataylab
 * o'chirilgan" — bu ikki xil ma'no. Birinchisida ro'yxat toraymaydi,
 * ikkinchisida esa aksi tanlanadi.
 */
const TriStateFilter = ({ query, label, disabled = false }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const value = searchParams.get(query); // null | '1' | '0'

  const handleChange = () => {
    // tanlanmagan → ha → yo'q → tanlanmagan
    const next = value === null ? '1' : value === '1' ? '0' : null;

    if (next === null) {
      searchParams.delete(query);
    } else {
      searchParams.set(query, next);
    }
    // Boshqa filtrlar kabi birinchi sahifaga qaytamiz
    searchParams.set('page', 1);
    setSearchParams(searchParams);
  };

  const hint =
    value === '1'
      ? t('common.filter.triState.yes')
      : value === '0'
        ? t('common.filter.triState.no')
        : t('common.filter.triState.any');

  return (
    <Tooltip title={hint} placement='right'>
      <FormControlLabel
        className='!ml-0'
        disabled={disabled}
        control={
          <Checkbox
            size='small'
            color='primary'
            checked={value === '1'}
            indeterminate={value === null}
            onChange={handleChange}
          />
        }
        label={
          <span className='text-[14px] text-ink'>
            {label}
            {value === '0' && (
              <span className='text-muted'>
                {' · '}
                {t('common.filter.triState.no')}
              </span>
            )}
          </span>
        }
      />
    </Tooltip>
  );
};

export default memo(TriStateFilter);
